import React, { useRef, useEffect } from 'react'
import cx from 'classnames'
import * as Icon from '@manychat/icons'

import * as l from '../../utils/localization/format'

import { SegmentedControlItemProps, IconNames } from './interfaces'
import { useSegmentedControl } from './SegmentedControlContext'

import cm from './SegmentedControl.module.css'

export const SegmentedControlItem = ({
  label,
  id,
  icon,
  value,
  disabled,
  ariaControls,
  ariaLabel,
  ...props
}: SegmentedControlItemProps) => {
  const { value: selectedValue, onChange, setActiveRef } = useSegmentedControl()
  const ref = useRef<HTMLButtonElement>(null)
  const isActive = selectedValue === value
  const IconComponent = icon ? Icon[icon as IconNames] : null

  const renderLabel = (label: string | (() => React.ReactNode)) => {
    if (typeof label === 'function') {
      return l.getString(label as ReturnType<typeof l.makeTranslate>)
    } else {
      return label
    }
  }

  useEffect(() => {
    if (isActive) setActiveRef(ref.current)
  }, [isActive, setActiveRef])

  const handleClick = () => {
    if (!disabled) {
      onChange(value)

      if (ariaControls) {
        setTimeout(() => {
          const content = document.getElementById(ariaControls)
          content && content.focus()
        })
      }
    }
  }

  return (
    <button
      ref={ref}
      id={id}
      role="tab"
      type="button"
      value={value}
      disabled={disabled}
      onClick={handleClick}
      className={cx(cm.segmentedControlItem, { [cm.active]: isActive })}
      aria-label={ariaLabel}
      aria-disabled={disabled || false}
      aria-selected={isActive}
      aria-controls={ariaControls}
      {...props}
    >
      {IconComponent && <IconComponent aria-hidden="true" size={16} />}
      {label && <span className="text-sm">{renderLabel(label)}</span>}
    </button>
  )
}
